__turbopack_context__.v({
  "className": "season_be3a96a5-module__hrfM1a__className",
  "variable": "season_be3a96a5-module__hrfM1a__variable",
});
